<template>
    <validation-observer ref="form" v-slot="{ meta }">
        <modal
            :id="modalId"
            :title="modalTitle"
            ok-title="Save"
            :ok-disabled="!meta.valid"
            @hidden="clearData"
            scrollable
            @shown="setInitialValues"
            @ok.prevent="createdEditPackage"
        >
            <div>
                <validation-provider name="name" v-slot="{ errors, handleChange }" rules="required">
                    <form-input
                        v-model="formObject.name"
                        label="Name:"
                        :error="errors[0]"
                        @input="handleChange"
                    ></form-input>
                </validation-provider>
                <form-textarea v-model="formObject.description" label="Description:"></form-textarea>
                <div class="d-flex">
                    <validation-provider
                        name="trial_period"
                        v-slot="{ errors, handleChange }"
                        rules="validFloat|required"
                    >
                        <form-input
                            v-model="formObject.trial_period"
                            label="Trial Period:"
                            :error="errors[0]"
                            class="mr-2"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                    <form-select class="unit-select" v-model="formObject.trial_period_unit" :options="unitOptions">
                    </form-select>
                </div>
                <div class="d-flex">
                    <validation-provider
                        name="billing_period"
                        v-slot="{ errors, handleChange }"
                        rules="validFloat|required"
                    >
                        <form-input
                            v-model="formObject.billing_period"
                            label="Billing Period:"
                            :error="errors[0]"
                            class="mr-2"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                    <form-select
                        class="unit-select"
                        v-model="formObject.billing_period_unit"
                        :options="unitOptions"
                    ></form-select>
                </div>
                <validation-provider
                    name="amount"
                    v-slot="{ errors, handleChange }"
                    rules="validFloat|required"
                    
                >
                    <form-input
                        v-model="formObject.amount"
                        label="Amount:"
                        :error="errors[0]"
                        @input="handleChange"
                    ></form-input>
                </validation-provider>
                <validation-provider name="status" v-slot="{ errors, handleChange }" rules="required" >
                    <form-select
                        v-model="formObject.status"
                        :options="statusOptions"
                        :error="errors[0]"
                        label="Status:"
                        description="Active = Displayed as option to property owners. Inactive =
                    Not displayed to property owners. Disabled = Disabled."
                        @input="handleChange"
                    ></form-select>
                </validation-provider>
                <validation-provider name="start_date" v-slot="{ errors, handleChange }" rules="required" >
                    <form-datepicker
                        v-model="formObject.date_from"
                        label="Date Begins:"
                        class="mt-2"
                        :hide-header="true"
                        :display-format="userUnicodeDateFormat"
                        :error="errors[0]"
                        @input="handleChange"
                    ></form-datepicker>
                </validation-provider>
                <validation-provider name="end_date" v-slot="{ errors, handleChange }"  rules="required">
                    <form-datepicker
                        v-model="formObject.date_to"
                        label="Date Ends:"
                        :hide-header="true"
                        :display-format="userUnicodeDateFormat"
                        :error="errors[0]"
                        @input="handleChange"
                        :min="formObject.date_from"
                    ></form-datepicker>
                </validation-provider>
                <form-checkbox v-model="formObject.coupons_allowed"> Coupons Allowed</form-checkbox>
                <validation-provider
                    name="notification_days"
                    v-slot="{ errors, handleChange }"
                    rules="required|validFloat"
                    
                >
                    <form-input
                        v-model="formObject.notification_days"
                        label="Notification Days:"
                        :error="errors[0]"
                        description="(Credit card billing reminder will be sent out X days before
                    card is charged)"
                        @input="handleChange"
                    ></form-input>
                </validation-provider>
                <validation-provider
                    name="max_properties"
                    v-slot="{ errors, handleChange }"
                    rules="validFloat"
                    
                >
                    <form-input
                        class="mt-2"
                        v-model="formObject.max_properties"
                        label="Max properties"
                        :error="errors[0]"
                        description=" PO that chooses this package will be restricted to having no
                    more than this number of properties. Zero or empty means
                    unlimited."
                        @input="handleChange"
                    ></form-input>
                </validation-provider>
                <validation-provider
                    name="grace_period"
                    v-slot="{ errors, handleChange }"
                    rules="required|validFloat"
                    
                >
                    <form-input
                        v-model="formObject.grace_period"
                        label="Grace Period:"
                        :error="errors[0]"
                        class="mt-2"
                        description="User will be able to use system this number of days after
                    subscription is suspended."
                        @input="handleChange"
                    ></form-input>
                </validation-provider>
            </div>
            <div>
                <h6 class="mt-3 mb-3">Access:</h6>
                <form-checkbox v-model="formObject.plugin_restrictions">Wordpress Related Package</form-checkbox>
                <form-checkbox v-model="formObject.disallow_triggers"> Disallow Triggers Access </form-checkbox>
                <form-checkbox v-model="formObject.disallow_gateways">Disallow Payment Gateway Access</form-checkbox>
            </div>
        </modal>
    </validation-observer>
</template>

<script>
import { mapGetters } from 'vuex';
import mapValues from 'lodash/mapValues';
import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
import FormDatepicker from '../../generic/form-datepicker/form-datepicker.vue';
import FormInput from '../../generic/form-input/form-input.vue';
import FormSelect from '../../generic/form-select/form-select.vue';
import FormTextarea from '../../generic/form-textarea/form-textarea.vue';
import modal from '../../generic/modal/modal.vue';
import { removeScrollMixin } from '../../../mixins/remove-scroll-mixin';
export default {
    props: {
        modalId: String,
        modalTitle: String,
        packageData: {
            type: Object,
            default: () => ({}),
        },
    },
    mixins: [removeScrollMixin],
    components: {
        modal,
        FormInput,
        FormTextarea,
        FormDatepicker,
        FormCheckbox,
        FormSelect,
    },
    data() {
        return {
            formObject: {
                name: null,
                description: null,
                trial_period: null,
                trial_period_unit: null,
                billing_period: null,
                billing_period_unit: null,
                amount: null,
                status: null,
                date_from: null,
                date_to: null,
                coupons_allowed: false,
                notification_days: null,
                max_properties: null,
                grace_period: null,
                plugin_restrictions: false,
                disallow_triggers: false,
                disallow_gateways: false,
            },
        };
    },
    computed: {
        ...mapGetters('header', ['userUnicodeDateFormat']),
        statusOptions() {
            return [
                { text: 'Active', value: 'ACTIVE' },
                { text: 'Inactive', value: 'INACTIVE' },
                { text: 'Disabled', value: 'DISABLED' },
            ];
        },
        unitOptions() {
            return [
                { text: 'days', value: 'day' },
                { text: 'weeks', value: 'week' },
                { text: 'months', value: 'month' },
                { text: 'years', value: 'year' },
            ];
        },
    },
    methods: {
        setInitialValues() {
            this.formObject = this.packageData.name ? { ...this.packageData } : this.formObject;
            this.formObject.trial_period_unit = this.packageData.trial_period_unit || this.unitOptions[0].value;
            this.formObject.billing_period_unit = this.packageData.billing_period_unit || this.unitOptions[0].value;
            this.$refs.form.setValues(this.formObject);
        },
        createdEditPackage() {
            if (this.formObject.max_properties === '') {
                this.formObject.max_properties = null;
            }
            this.$emit('submit', this.formObject);
        },
        clearData() {
            if (!this.packageData.name) {
                const { plugin_restrictions, disallow_triggers, disallow_gateways, coupons_allowed, ...properties } =
                    this.formObject;
                this.formObject = {
                    ...mapValues(properties, () => null),
                    ...mapValues(
                        {
                            plugin_restrictions,
                            disallow_triggers,
                            disallow_gateways,
                            coupons_allowed,
                        },
                        () => false
                    ),
                };
            }
        },
    },
};
</script>
,

<style lang="scss" scoped>
:deep(.unit-select) {
    margin-top: 2rem;
}
</style>
